import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
  useColorScheme,
} from "@mui/material";
import { DarkMode, Password, Smartphone } from "@mui/icons-material";
import { ValidatedTextField } from "../../components/ValidatedTextField";
import { checkMobileValid } from "../../helper/utils";
import { login, sendSms } from "../../network/api/account.api";
import { connect } from "react-redux";
import { authActions } from "../../helper/redux/actions/AuthActions";
import Lottie from "lottie-react";
import { useNavigate } from "react-router";

const NewLogin = (props) => {
  const navigate = useNavigate();
  const { mode, setMode } = useColorScheme();
  const statusEnum = {
    clear: 0,
    loadingSendSms: 1,
    smsSent: 2,
    loadingConfirm: 3,
  };
  const [status, setStatus] = useState(statusEnum.clear);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [code, setCode] = useState(null);
  const [smsError, setSmsError] = useState(null);
  const [codeError, setCodeError] = useState(null);
  const [canSendCode, setCanSendCode] = useState(false);
  const [canConfirmCode, setCanConfirmCode] = useState(false);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [sendBtnTitle, setSendBtnTitle] = useState("ارسال کد تایید");

  useEffect(() => {
    let interval = null;
    if (status === statusEnum.smsSent && !isTimerActive) {
      setIsTimerActive(true);
      let count = 120;
      let interval = setInterval(() => {
        if (count > 0) {
          count--;
          setSendBtnTitle("ارسال مجدد " + count);
          setCanSendCode(false);
        } else {
          setSendBtnTitle("ارسال مجدد ");
          setIsTimerActive(false);
          setCanSendCode(true);
          setStatus(statusEnum.clear);
          clearInterval(interval);
        }
      }, 1000);
    }
    return () => {
      setIsTimerActive(false);
      clearInterval(interval);
    };
  }, [status]);

  useEffect(() => {
    try {
      if (window.location.pathname == "/settings/exit") {
        navigate("/dashBoard");
        setTimeout(() => {
          window.location = window.location;
        }, 1000);
      }
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (mode === "system") {
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      setMode(mediaQuery.matches ? "dark" : "light");
      const handler = (e) => setMode(e.matches ? "dark" : "light");
      mediaQuery.addEventListener("change", handler);
      return () => mediaQuery.removeEventListener("change", handler);
    }
  }, [mode]);

  if (!mode) {
    return null;
  }

  function submitForm(event) {
    event.preventDefault();
    setStatus(statusEnum.loadingSendSms);
    sendSms({
      phoneNumber: phoneNumber,
      Application: "WEBFOODWORKS",
    })
      .then((data) => {
        setStatus(statusEnum.smsSent);
        setSmsError(null);
      })
      .catch((err) => {
        setStatus(statusEnum.clear);
        setSmsError(err?.response?.data?.Message || "خطا در ارسال پیامک.");
      });
  }

  function mobileValidator(number) {
    setSmsError(null);
    setPhoneNumber(number);
    if (!checkMobileValid(number)) {
      setCanSendCode(false);
      return "شماره موبایل صحیح نیست";
    }
    setCanSendCode(true);
  }

  function codeValidation(number) {
    setCodeError(null);
    if (number?.toString()?.length < 4) {
      setCanConfirmCode(false);
      return "کد 4 رقم است";
    }
    setCanConfirmCode(true);
    setCode(number);
  }

  function confirmCode(e) {
    console.log(e);
    try {
      setStatus(statusEnum.loadingConfirm);
      login({
        username: phoneNumber,
        password: e,
        Application: "WEBFOODWORKS",
      })
        .then((data) => {
          try {
            setCodeError(null);
          } catch (e) {}
          try {
            props.SetUser(data.data.Data);
          } catch (e) {}
          try {
            props.SetToken(data.data.Data.Token);
          } catch (e) {}
          try {
            props.SetRefreshToken(data.data.Data.RefreshToken);
          } catch (e) {}
        })
        .catch((err) => {
          console.log(err);
          setStatus(statusEnum.smsSent);
          setCodeError(
            err?.response?.data?.Message || "کد وارد شده معتبر نیست.",
          );
        });
    } catch (e) {}
  }

  return (
    <>
      <Grid
        container
        className={mode == "light" ? "loginBgLight" : "loginBgDark"}
        direction={"row"}
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        style={{ minHeight: "100vh" }}
        columns={18}
      >
        <Grid size={{ xs: 18, md: 8 }} justifyItems={"center"}>
          <Card sx={{ borderRadius: 8 }}>
            <CardHeader
              action={
                <IconButton
                  onClick={(e) => setMode(mode == "light" ? "dark" : "light")}
                >
                  <DarkMode />
                </IconButton>
              }
            />
            <CardContent sx={{ px: 5, pb: "80px !important" }}>
              <form onSubmit={submitForm}>
                <Grid container direction={"column"}>
                  <img
                    width={"300px"}
                    src={
                      mode == "light"
                        ? "/logoTypo300.png"
                        : "/logoTypo300Dark.png"
                    }
                  />

                  <Typography sx={{ mt: 7 }} variant={"subtitle1"}>
                    ورود با کد یکبار مصرف
                  </Typography>
                  <Typography
                    sx={{ mt: 7, textAlign: "start" }}
                    variant={"body2"}
                  >
                    لطفا شماره موبایل خود را وارد کنید
                  </Typography>
                  <ValidatedTextField
                    label="موبایل"
                    variant="outlined"
                    name={"phoneNumber"}
                    sx={{ mt: 2 }}
                    isMobile={true}
                    validator={mobileValidator}
                    disabled={status !== statusEnum.clear}
                    required={true}
                    slotProps={{
                      input: {
                        endAdornment: <Smartphone color={"primary"} />,
                      },
                      htmlInput: {
                        maxLength: 11,
                      },
                    }}
                  />

                  {smsError && (
                    <Alert sx={{ mt: 1 }} severity={"error"}>
                      {smsError}
                    </Alert>
                  )}

                  <Button
                    color={"primary"}
                    loading={status === statusEnum.loadingSendSms}
                    sx={{ mt: 1 }}
                    disabled={!canSendCode}
                    loadingPosition="start"
                    type={"submit"}
                    variant="contained"
                  >
                    {sendBtnTitle}
                  </Button>
                  {(status === statusEnum.smsSent ||
                    status === statusEnum.loadingConfirm) && (
                    <>
                      <Typography
                        sx={{ mt: 4, textAlign: "start" }}
                        variant={"body2"}
                      >
                        لطفا کد دریافت شده در پیامک را وارد نمایید
                      </Typography>
                      <ValidatedTextField
                        label="کد دریافتی"
                        variant="outlined"
                        name={"Code"}
                        maxLength={4}
                        disabled={status === statusEnum.loadingConfirm}
                        sx={{
                          mt: 2,
                          input: {
                            textAlign: "center",
                            letterSpacing: "0.5rem",
                          },
                        }}
                        type={"number"}
                        trigerOn={4}
                        triger={(e) => confirmCode(e.target.value)}
                        validator={codeValidation}
                        required={true}
                        slotProps={{
                          input: {
                            endAdornment: <Password color={"primary"} />,
                          },
                        }}
                      />
                      {codeError && (
                        <Alert severity={"error"}>{codeError}</Alert>
                      )}
                      <Button
                        color={"primary"}
                        loading={status === statusEnum.loadingConfirm}
                        sx={{ mt: 1 }}
                        disabled={!canConfirmCode}
                        loadingPosition="start"
                        onClick={(e) => confirmCode(code)}
                        variant="contained"
                      >
                        تایید
                      </Button>
                    </>
                  )}
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default connect(null, authActions)(NewLogin);
